<template>
  <header :class="['header', { 'header-fixed': isScrolled, 'light-header': isLightSection, 'home-header': isHome }]">
    <div class="container">
      <div class="header-wrapper">
        <div class="logo">
          <img v-if="isHome && !isLightSection" :src="require('@/assets/logo-white.png')" alt="江苏友辰工程装备有限公司">
          <img v-else :src="require('@/assets/logo-dark.png')" alt="江苏友辰工程装备有限公司">
        </div>
        <div class="nav-toggle" @click="toggleMobileMenu">
          <div class="hamburger" :class="{ active: mobileMenuOpen }">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <nav :class="['nav', { 'nav-open': mobileMenuOpen }]">
          <ul class="nav-list">
            <li v-for="(item, index) in navItems" :key="index">
              <router-link :to="item.path" :class="{ active: $route.path === item.path }" @click="mobileMenuOpen = false">
                <span class="nav-icon"><i :class="item.icon"></i></span>
                {{ item.name }}
              </router-link>
            </li>
          </ul>
          <div class="nav-contact">
            <a href="tel:025-12345678" class="phone-link"><i class="el-icon-phone"></i> 025-12345678</a>
          </div>
        </nav>
        <!-- 移动端菜单背景遮罩 -->
        <div class="mobile-overlay" v-show="mobileMenuOpen" @click="toggleMobileMenu"></div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    isLightSection: {
      type: Boolean,
      default: false
    },
    isHome: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isScrolled: false,
      mobileMenuOpen: false,
      navItems: [
        { name: '首页', path: '/', icon: 'el-icon-s-home' },
        { name: '关于我们', path: '/about', icon: 'el-icon-s-custom' },
        { name: '产品服务', path: '/products', icon: 'el-icon-s-cooperation' },
        // { name: '经典案例', path: '/cases', icon: 'el-icon-picture' },
        { name: '新闻资讯', path: '/news', icon: 'el-icon-document' },
        { name: '联系我们', path: '/contact', icon: 'el-icon-phone-outline' }
      ]
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleResize)
    // 初始检查
    this.handleScroll()
    this.handleResize()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    handleResize() {
      if (window.innerWidth > 768 && this.mobileMenuOpen) {
        this.mobileMenuOpen = false
      }
    },
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      // 当菜单打开时，禁止滚动
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : ''
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  display: flex;
  justify-content: center;
}

/* 首页特殊样式 */
.home-header {
  background-color: transparent;
  box-shadow: none;
}

/* 亮暗模式支持 */
.light-header:not(.home-header) {
  background-color: #ffffff;
}

.home-header.light-header {
  background-color: transparent;
}

.header:not(.light-header):not(.home-header) .nav-list li a {
  color: #333;
}

.home-header:not(.light-header) .nav-list li a {
  color: #ffffff;
}

.home-header:not(.light-header) .hamburger span {
  background-color: #fff;
}

.header-fixed {
  background-color: rgba(255, 255, 255, 0.95);
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.1);
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 15px;
  box-sizing: border-box;
}

.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 0;
  width: 100%;
}

.logo {
  display: flex;
  align-items: center;
}

.logo img {
  height: 50px;
  transition: all 0.3s ease;
}

.nav {
  display: flex;
  align-items: center;
}

.nav-list {
  display: flex;
  gap: 30px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.nav-list li a {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  transition: all 0.3s ease;
  position: relative;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.nav-icon {
  margin-right: 5px;
  font-size: 18px;
  color: #1e50a2;
  display: none;
}

.nav-list li a:hover,
.nav-list li a.active {
  color: #1e50a2;
}

.nav-list li a.active:after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1e50a2;
}

.nav-contact {
  display: none;
}

.phone-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #1e50a2;
  font-weight: bold;
  gap: 5px;
  padding: 10px 20px;
  background-color: rgba(30, 80, 162, 0.1);
  border-radius: 50px;
  margin-top: 15px;
  transition: all 0.3s;
}

.phone-link:hover {
  background-color: #1e50a2;
  color: #fff;
}

/* 汉堡菜单按钮 */
.nav-toggle {
  display: none;
  cursor: pointer;
  z-index: 1001;
}

.hamburger {
  width: 30px;
  height: 24px;
  position: relative;
  cursor: pointer;
}

.hamburger span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #1e50a2;
  position: absolute;
  left: 0;
  transition: all 0.3s ease;
}

.hamburger span:nth-child(1) {
  top: 0;
}

.hamburger span:nth-child(2) {
  top: 10px;
}

.hamburger span:nth-child(3) {
  top: 20px;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg);
  top: 10px;
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg);
  top: 10px;
}

.mobile-overlay {
  display: none;
}

@media (max-width: 1024px) {
  .nav-list {
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .header-wrapper {
    padding: 12px 0;
  }

  .nav-toggle {
    display: block;
  }

  .nav {
    position: fixed;
    top: 0;
    right: -280px;
    width: 280px;
    height: 100vh;
    background-color: #fff;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
    transition: all 0.4s ease;
    z-index: 1001;
    padding: 80px 0 0;
    overflow-y: auto;
    display: block;
  }

  .nav-open {
    right: 0;
  }

  .nav-list {
    flex-direction: column;
    gap: 0;
  }

  .nav-list li {
    width: 100%;
  }

  .nav-list li a {
    display: block;
    padding: 15px 25px;
    border-bottom: 1px solid #f0f0f0;
    color: #333 !important;
  }

  .nav-icon {
    display: inline-block;
    margin-right: 10px;
  }

  .nav-list li a.active:after {
    display: none;
  }

  .nav-list li a.active {
    background-color: #f5f8ff;
  }

  .nav-contact {
    display: block;
    padding: 20px;
    text-align: center;
  }

  .mobile-overlay {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .logo img {
    height: 36px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 10px;
  }

  .logo img {
    height: 32px;
  }
}
</style>


